import { render, staticRenderFns } from "./AddAirport.vue?vue&type=template&id=97f1eea4&scoped=true&"
import script from "./AddAirport.vue?vue&type=script&lang=js&"
export * from "./AddAirport.vue?vue&type=script&lang=js&"
import style0 from "./AddAirport.vue?vue&type=style&index=0&id=97f1eea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1eea4",
  null
  
)

export default component.exports